module.exports = __webpack_public_path__ + "img/reduced-crime.3dacf719.svg";